<template>
  <div class="w-full" data-testid="account-type-modal">
    <div class="mb-4 text-center text-white text-2xl font-bold leading-[30px]">
      Choose account type
    </div>
    <div class="mb-6 text-center text-white/80 text-sm">
      Please select one option to continue.
    </div>

    <div class="flex flex-col gap-3">
      <button
        type="button"
        :class="businessButtonClass"
        @click="$emit('selected', 'business')"
        data-testid="account-type-business"
      >
        <lib-icon name="general/building-small-business/outline" size="20" class="shrink-0" />
        <span class="flex-1 text-left">
          <span class="block leading-5">Business</span>
          <span :class="businessSubtitleClass">For teams and organizations</span>
        </span>
      </button>

      <button
        type="button"
        :class="personalButtonClass"
        @click="$emit('selected', 'personal')"
        data-testid="account-type-personal"
      >
        <lib-icon name="users/user/outline" size="20" class="shrink-0" />
        <span class="flex-1 text-left">
          <span class="block leading-5">Personal</span>
          <span :class="personalSubtitleClass">For individual use</span>
        </span>
      </button>

      <button
        type="button"
        class="mt-2 text-[#6CBFFF] text-base leading-[1.2rem] cursor-pointer"
        @click="$emit('close')"
      >
        Cancel
      </button>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import LibIcon from '@/components/ui/LibIcon.vue'

export default {
  name: 'AccountTypeSelectionModal',
  components: {
    LibIcon,
  },
  computed: {
    ...mapState('auth', ['accountType']),
    businessButtonClass() {
      const isSelected = this.accountType === 'business'
      return [
        'w-full px-5 py-3 rounded-xl inline-flex items-center gap-3 transition duration-160 cursor-pointer text-base font-medium border-2',
        isSelected
          ? 'bg-[#6CBFFF] text-black border-[#C7E8FF]'
          : 'bg-[#223343] text-white border-transparent hover:bg-[#2B4257]'
      ]
    },
    personalButtonClass() {
      const isSelected = this.accountType === 'personal'
      return [
        'w-full px-5 py-3 rounded-xl inline-flex items-center gap-3 transition duration-160 cursor-pointer text-base font-medium border-2',
        isSelected
          ? 'bg-[#6CBFFF] text-black border-[#C7E8FF]'
          : 'bg-[#293F52] text-white border-transparent hover:bg-[#314b61]'
      ]
    },
    businessSubtitleClass() {
      return [
        'block text-xs font-normal',
        this.accountType === 'business' ? 'text-black/70' : 'text-white/80'
      ]
    },
    personalSubtitleClass() {
      return [
        'block text-xs font-normal',
        this.accountType === 'personal' ? 'text-black/70' : 'text-white/80'
      ]
    }
  },
  emits: ['selected', 'close']
}
</script>
